export enum VehicleApiRoutes {
  VehicleById = '/vehicles/:id',
  VehicleDetails = '/vehicles/:id/details',
  VehicleYears = '/vehicles/years',
  VehicleMakes = '/vehicles/years/:id/makes',
  VehicleModels = '/vehicles/makes/:id/models',
  VehicleTrims = '/vehicles/models/:id/trims',
  VehicleVinDecode = '/vehicles/:id/decode',
}
